import React, { Fragment } from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Paper from 'housecall-ui/dist/DesignSystem/Surfaces/Paper/Paper';
import ChecklistAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ChecklistAppIcon';

const ChecklistsStrategy = {
  previewInfo: {
    name: 'Checklists',
    iconSvg: <ChecklistAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Checklists',
    category: 'Make sure your technicians never miss a step',
    details: <>Ensure every job is done right with custom checklists.</>,
    iconSvg: <ChecklistAppIcon size="xlarge" />,
  },
  media: {
    image: (
      <div style={{ width: '100%', textAlign: 'center' }}>
        <Paper style={{ width: 'fit-content' }}>
          <img
            style={{ width: 620 }}
            src="https://static-assets.housecallpro.com/images/checklist_appstore_screenshot.png"
            alt="checklist_appstore_screenshot"
          />
        </Paper>
      </div>
    ),
  },
  sellingPoints: {
    headline: 'Never miss a step again',
    description: (
      <div>
        You can&apos;t be on every job, but now you can make sure every job goes as well as it would if you were. With
        custom checklists, you can build out work flows with specific steps and required actions to make sure that
        services are performed at the highest quality.
        <br />
        <br />
        Create a home inspection to be performed on each job, build out a detailed install checklist to make sure no
        critical steps are missed, or document a standard maintenance visit all within our checklist feature. Checklists
        can also be made required so that all critical actions have to be performed before completing work.
      </div>
    ),
    orderedPoints: '',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: false,
    hideCard: true,
  },
  supportContacts: [],
};

export default ChecklistsStrategy;
